export default __webpack_public_path__ + "static/media/motor-vehicle-bg1.8574f3b4.png";